/// <reference path="../../../teva/selectbox/selectbox.ts" />
/// <reference path="../../common/resources/resources.ts" />
/// <reference path="../../common/common/common.ts" />

namespace OfficeGuy.CRM {
    export class SchemaPicker {
        static InitEditors(Container?): void {
            $("input.schemapicker", Container).each(function () {
                var $Hidden = $(this);
                if ($Hidden.val() == "" || $Hidden.val() == "0")
                    $Hidden.val(null);
                //Hidden.attr("data-text", Hidden.data("schemaname"));
                $Hidden.attr("data-text", $Hidden.val() == "" || $Hidden.val() == "0" ? OfficeGuy.Resources.GetString("CRM", "SchemaPicker_PlaceHolder") : $Hidden.data("schemaname"));
            });
            Teva.SelectBox.Enable($("input.schemapicker", Container), {
                QueryMethod: function (Terms, QueryByID, PageIndex, Callback) {
                    Common.AjaxRequest({
                        Method: 'GET',
                        URL: "/schema/schemapicker/?term=" + encodeURI(Terms),
                        SuccessMethod: function (Response) {
                            Callback({
                                more: false,
                                results: Response
                            });
                        },
                        ShowLoading: false
                    });
                },
                OnChange: function (Value, Text, Data, Instance) {
                    Instance.$Input.nextAll('.schemapickername').val(Text);
                },
                AllowClear: false,
                PlaceHolderText: OfficeGuy.Resources.GetString("CRM", "SchemaPicker_PlaceHolder"),
            });
        }
    }
}

$(document).on("Teva.InitEditors", function (Event, Container) {
    OfficeGuy.CRM.SchemaPicker.InitEditors(Container);
});